export const getError = (error) => {
  if (error?.message) {
    if (error.message.key) {
      return error.message.key;
    } else {
      return error.message;
    }
  }
};
